<template>
    <span>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-tabs :key="isSmallerScreen" :position="isSmallerScreen ? 'top' : 'left'" :value="active_step"
                    class="tabs-shadow-none" id="profile-tabs">

                    <vs-tab :label="!isSmallerScreen ? 'RM Stock' : ''" icon="icon-database" icon-pack="feather"
                        v-if="$canAny(['view-raw-material-stock-inventory'])">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <RawMaterialStockReport />
                        </div>
                    </vs-tab>

                    <vs-tab :label="!isSmallerScreen ? 'FG Stock' : ''" icon="icon-database" icon-pack="feather"
                        v-if="$canAny(['view-product-stock-inventory'])">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <FormulationStockReport />
                        </div>
                    </vs-tab>

                    <vs-tab :label="!isSmallerScreen ? 'Sundry Stock' : ''" icon="icon-database" icon-pack="feather"
                        v-if="$canAny(['view-sundry-item-stock-inventory'])">
                        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                            <SundryStockReport/>
                        </div>
                    </vs-tab>

                </vs-tabs>
            </div>
        </div>
    </span>
</template>
  
<script>

import RawMaterialStockReport from './RawMaterialStockReport.vue';
import FormulationStockReport from './FormulationStockReport.vue'
import SundryStockReport from './SundryStockReport.vue'

export default {
    name: 'StockReportHome',
    components: {
        RawMaterialStockReport,
        FormulationStockReport,
        SundryStockReport
    },
    data() {
        return {
            active_step: this.$route.query.step ? this.$route.query.step : '0'
        }
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        }
    },
    methods: {}
}
</script>
  
<style lang="scss">
#profile-tabs {
    .vs-tabs--content {
        padding: 0;
    }
}
</style>
  